import { css } from 'emotion';

import { fonts } from '../styles';

export const loadingContent = css`
  padding: 20px 40px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const loadingMessage = css`
  font-size: ${fonts.size.large};
  margin: 0 0 20px;
`;
